"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SUPPLIER_PAYMENT_SERIES = exports.PURCHASE_BILL_SERIES = void 0;
exports.purchaseBillIntent = purchaseBillIntent;
exports.paymentSettlementTotal = paymentSettlementTotal;
exports.supplierPaymentPostingIntent = supplierPaymentPostingIntent;
const money_1 = require("../money");
const document_rules_1 = require("../posting/document-rules");
const receipt_1 = require("../sales/receipt");
const line_tax_1 = require("../tax/line-tax");
/** سلسلة فواتير الموردين وسداداتهم — مستقلة، والصيغة `BLOCKED-ACCOUNTING`. */
exports.PURCHASE_BILL_SERIES = 'PB';
exports.SUPPLIER_PAYMENT_SERIES = 'PY';
/**
 * قيد فاتورة مورد آجلة: مدين كل حساب مصروف بمجموع صافى سطوره، ومدين ضريبة المدخلات
 * للسطور الخاضعة **القابلة للخصم** بأثر قاعدتها، ودائن الموردين بالإجمالى (بمعرّف المورد
 * والفاتورة). الضريبة غير القابلة للخصم تُحمَّل على حساب سطرها نفسه — هكذا تقرر القاعدة
 * المعتمدة بعلَم `recoverable`، لا هذا الكود.
 */
function purchaseBillIntent(ctx, input) {
    const { bill } = input;
    const costs = [];
    const taxLines = [];
    for (const line of bill.lines) {
        let cost = line.net;
        // أثر القاعدة يبقى على سطر التكلفة حين لا يحمله سطر مدخلات: ضريبة صفر، أو غير قابلة للخصم
        let carried = line.tax?.snapshot ?? null;
        if (line.tax && line.tax.amount.isPositive()) {
            if (line.tax.snapshot.recoverable) {
                const account = input.inputTaxAccountOf?.({ ruleId: line.tax.snapshot.ruleId }) ?? ctx.accounts.inputTax;
                taxLines.push((0, document_rules_1.debitLine)(account, line.tax.amount, ctx.currency, { tax: line.tax.snapshot }));
                carried = null;
            }
            else {
                cost = cost.add(line.tax.amount);
            }
        }
        costs.push({ account: line.account, amount: cost, tax: carried });
    }
    const lines = [];
    for (const cost of (0, line_tax_1.groupByAccountAndTax)(costs)) {
        if (cost.amount.isPositive()) {
            lines.push((0, document_rules_1.debitLine)(cost.account, cost.amount, ctx.currency, { tax: cost.tax }));
        }
    }
    lines.push(...taxLines);
    lines.push((0, document_rules_1.creditLine)(ctx.accounts.payable, bill.total, ctx.currency, {
        counterparty: { type: 'supplier', id: input.supplierId, allocationRef: input.billId },
    }));
    return {
        companyId: ctx.companyId,
        sourceType: 'purchase_invoice',
        sourceId: input.sourceId,
        postingDate: input.postingDate,
        idempotencyKey: input.idempotencyKey,
        reference: input.reference ?? null,
        memo: input.memo ?? null,
        createdBy: ctx.createdBy ?? null,
        lines,
    };
}
/** ما يسدده السداد من ذمة المورد: النقد مع الخصم من المنبع. */
function paymentSettlementTotal(amount, withholding) {
    return money_1.Money.of(amount).add(withholding?.amount ?? money_1.Money.zero());
}
/**
 * قيد السداد: مدين الموردين سطرًا لكل فاتورة بمرجعها وسطرًا للباقى تحت الحساب، ودائن
 * النقدية بالمدفوع، ودائن «ضرائب خصم مستحقة» بما خصمناه من المورد بأثر ضريبى. لا مصروف
 * هنا — السداد يُقفل التزامًا نشأ عند فاتورة المورد، والخصم ينقله من المورد للمصلحة.
 */
function supplierPaymentPostingIntent(ctx, input) {
    const lines = [];
    for (const allocation of input.plan.allocations) {
        lines.push((0, document_rules_1.debitLine)(ctx.accounts.payable, allocation.amount, ctx.currency, {
            counterparty: {
                type: 'supplier',
                id: input.supplierId,
                allocationRef: allocation.documentId,
            },
        }));
    }
    if (input.plan.unallocated.isPositive()) {
        lines.push((0, document_rules_1.debitLine)(ctx.accounts.payable, input.plan.unallocated, ctx.currency, {
            counterparty: { type: 'supplier', id: input.supplierId, allocationRef: null },
        }));
    }
    lines.push((0, document_rules_1.creditLine)(input.sourceAccount, money_1.Money.of(input.amount), ctx.currency, {
        cashboxId: input.cashboxId ?? null,
    }));
    if (input.withholding && input.withholding.amount.isPositive()) {
        lines.push((0, document_rules_1.creditLine)(ctx.accounts.withholdingPayable, input.withholding.amount, ctx.currency, {
            counterparty: { type: 'supplier', id: input.supplierId, allocationRef: null },
            tax: (0, receipt_1.withholdingSnapshot)(input.withholding, input.postingDate, 'withholding_on_payment'),
        }));
    }
    return {
        companyId: ctx.companyId,
        sourceType: 'supplier_payment',
        sourceId: input.sourceId,
        postingDate: input.postingDate,
        idempotencyKey: input.idempotencyKey,
        reference: input.reference ?? null,
        memo: input.memo ?? null,
        createdBy: ctx.createdBy ?? null,
        lines,
    };
}
//# sourceMappingURL=bill.js.map